module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm7": "",
      "md4": ""
    }
  }, [_c('ul', {
    staticClass: "acron-bots",
    class: {
      'ordered': _vm.ordered, 'bold': _vm.bold
    }
  }, _vm._l((_vm.bots), function(bot, index) {
    return _c('li', {
      key: index,
      class: bot.visto ? 'bullet-dav-ok-2' : ''
    }, [_c('button', {
      staticClass: " animated flipInY",
      class: 'dura_' + index,
      attrs: {
        "id": 'bot-slide-' + index
      },
      on: {
        "click": function($event) {
          _vm.botClick(index + 1, bot)
        }
      }
    }, [_c('p', {
      staticClass: "acron-bots-text hvr-grow",
      domProps: {
        "innerHTML": _vm._s(bot.nameDesing)
      }
    })])])
  }))]), _vm._v(" "), _c('v-flex', {
    staticClass: "aligner",
    attrs: {
      "xs12": "",
      "sm5": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "unstyled-focus",
    attrs: {
      "tabindex": "0",
      "id": "contenidos",
      "aria-label": 'Contenido ' + _vm.bots[_vm.nombreCurrentBot].name
    }
  }), _c('br'), _vm._v(" "), _vm._l((_vm.bots), function(item, index) {
    return (_vm.contenido === (index + 1)) ? _c('div', {
      key: 'slide-cont' + index,
      attrs: {
        "tabindex": "0"
      }
    }, [_vm._t('cont-' + index)], 2) : _vm._e()
  }), _vm._v(" "), (!_vm.finContenidos) ? _c('button', {
    attrs: {
      "aria-label": "Volver a la lista anterior"
    },
    on: {
      "click": function($event) {
        _vm.backMenu()
      }
    }
  }) : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-040ebd9b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/BotsAcronimo.vue
// module id = 942
// module chunks = 1